'use client';

import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { PaperAirplaneIcon } from '@heroicons/react/20/solid';
import {
  getBranchData,
  getBranchCodeFromPath,
  getCurrentBranch,
} from '@/lib/config/branches-config';
import { getLeadFormBranch } from '@/lib/forms/region';
import Region from './RegionOption';

export default function MobileRegionBar() {
  const pathname = usePathname() || '/';
  const currentBranchCode = getLeadFormBranch(pathname, useSearchParams().toString());
  const currentBranch = getBranchData(currentBranchCode) || getCurrentBranch();

  if (!currentBranch) {
    return null;
  }

  return (
    <div className="w-full border-b border-white/20 bg-header-gradient">
      <div className="w-full max-w-[1536px] mx-auto  px-4 lg:px-8 flex items-center justify-between">
        {/* Левая часть - выбор города */}
        <div className="flex-1">
          <Region asButton={true} className="text-sm font-medium text-white" />
        </div>

        {/* Правая часть - иконки контактов */}
        <div className="flex items-center gap-3">
          {/* Телефон */}
          {currentBranch.phone && (
            <a
              href={`tel:${currentBranch.phone.replace(/[^+\d]/g, '')}`}
              className="group flex items-center gap-1.5 p-2 text-white hover:text-white/80 transition-colors"
              aria-label="Телефон"
            >
              <PhoneIcon className="h-5 w-5" />
              <span className="hidden text-sm font-medium text-white transition-colors group-hover:text-white/80 lg:inline">
                {currentBranch.phone}
              </span>
            </a>
          )}

          {/* Email */}
          {currentBranch.email && (
            <a
              href={`mailto:${currentBranch.email}`}
              className="group flex items-center gap-1.5 p-2 text-white hover:text-white/80 transition-colors"
              aria-label="Email"
            >
              <EnvelopeIcon className="h-5 w-5" />
              <span className="hidden text-sm font-medium text-white transition-colors group-hover:text-white/80 lg:inline">
                {currentBranch.email}
              </span>
            </a>
          )}

          {/* Telegram */}
          {currentBranch.telegram && (
            <a
              href={currentBranch.telegram}
              target="_blank"
              rel="noopener noreferrer"
              className="p-1 transition-colors"
              aria-label="Telegram"
            >
              <img
                alt={'Telegram'}
                src="/icon/Telegram.svg"
                className="h-6 w-6"
              />
            </a>
          )}

          <a
            href={
              'https://max.ru/u/f9LHodD0cOKkTKl7uHBoM9NKG6P5BepSPikVN6knzBtuCqb1-uy75Fth6c8'
            }
            target="_blank"
            rel="noopener noreferrer"
            className="p-1 transition-colors"
            aria-label="max"
          >
            <img
              alt={'max'}
              src="/icon/max.svg"
              className="h-6 w-6"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
